import React, { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom';
import {  ValueCard } from '../../models/models';
import HeaderComponent from '../../components/HeaderComponent';
import { format } from 'date-fns';
import FileDownloadComponent from './FileDownloadComponent';
import './DisplayDomainData.css'


const DisplayDomainData: React.FC = () => {

    const { id } = useParams<{ id: string }>();
    const [valueCard, setValueCard] = useState<ValueCard | null>(null);
    const [byteArray, setByteArray] = useState<number[]>([]);
    const [showScoreInfo, setShowScoreInfo] = useState(false);

    const toggleScoreInfo = () => {
        setShowScoreInfo(!showScoreInfo);
    }

    useEffect(() => {
        fetch(`/api/domain-models/getDomainData?id=${id}`)
            .then((response) => response.json())
            .then((data) => setValueCard(data))
            .catch((error) => console.error('Error fetching ValueCard:', error));
    }, [id]);

    useEffect(() => {
        const fetchByteArray = async () => {
          const response = await fetch(`/api/domain-models/getDomainModel?id=${id}`);
          const data = await response.arrayBuffer();
          setByteArray(Array.from(new Uint8Array(data)));
        };
    
        fetchByteArray();
      }, []);

    if (!valueCard) {
        return <p>Loading...</p>;
    }

    return (
        <div>
            <HeaderComponent />
            <h1 className='model-name'>{valueCard.modelName}</h1>
            <div className="cards-container">
                
                <div className="card">
                <h3>General</h3>
                <div className="card-content">
                    <div className="label-g">Model language:</div>
                    <div className="value-g">{valueCard.modelLang}</div>
                </div>
                <div className="card-content">
                    <div className="label-g">Parser check:</div>
                    <div className="value-g">{valueCard.parserCheck ? 'Yes' : 'No'}</div>
                </div>
                <div className="card-content">
                    <div className="label-g">Planner evaluation:</div>
                    <div className="value-g">{valueCard.planner_eval ? 'Yes' : 'No'}</div>
                </div>
                <div className="card-content">
                    <div className="label-g">Real world score:</div>
                    <div className="value-g">{valueCard.realWorldScore} / 40 </div>
                </div>
                <div className="card-content">
                    <div className="label-g">Ethical consideration:</div>
                    <div className="value-g">{valueCard.ethicalConsideration}</div>
                </div>
                <div>{byteArray.length > 0 && <FileDownloadComponent byteArray={byteArray} lang={valueCard.modelLang} domainName={valueCard.modelName} />}</div>
                </div>
                <div className='card'>
                    <h3>Description</h3>
                    <div className="card-content">
                        <div className="label">Purpose:</div>
                        <div className="value">{valueCard.description.purpose}</div>
                    </div>
                    <div className="card-content">
                        <div className="label">Use case:</div>
                        <div className="value">{valueCard.description.useCase}</div>
                    </div>
                    <div className="card-content">
                        <div className="label">Category:</div>
                        <div className="value">{valueCard.description.category}</div>
                    </div>
                </div>
                <div className="card">
                    <h3>Basic information</h3>
                    <div className="card-content">
                        <div className="label-g">Developer:</div>
                        <div className="value-g">{valueCard.basicInfo.modelDeveloper}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Created on:</div>
                        <div className="value-g">{format(new Date(valueCard.basicInfo.createDate), 'yyyy-MM-dd')}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Last updated on:</div>
                        <div className="value-g">{format(new Date(valueCard.basicInfo.lastUpdated), 'yyyy-MM-dd')}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Verson:</div>
                        <div className="value-g">{valueCard.basicInfo.version}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">License:</div>
                        <div className="value-g">{valueCard.basicInfo.license}</div>
                    </div>
                </div>
                <div className="card">
                    <h3>Contacts and references</h3>
                    <div className="card-content">
                        <div className="label">Contact:</div>
                        <div className="value">{valueCard.basicInfo.contact}</div>
                    </div>
                    <div className="card-content">
                        <div className="label">Reference document:</div>
                        <div className="value">{valueCard.basicInfo.refDoc}</div>
                    </div>
                    <div className="card-content">
                        <div className="label">Source code:</div>
                        <div className="value">{valueCard.basicInfo.source}</div>
                    </div>
                </div>
                
                <div className='card'>
                    <h3>Model parameters</h3>
                    <div className="card-content">
                        <div className="label-g">Sub-language:</div>
                        <div className="value-g">{valueCard.modelParams.mdlSubLang}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Is model typed?</div>
                        <div className="value-g">{valueCard.modelParams.isModelTyped ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Number of types:</div>
                        <div className="value-g">{valueCard.modelParams.noTypes}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Types:</div>
                        <div className="value-g">
                        {valueCard.modelParams.typeList.map(type => (
                            <li key={type.typeID}>{type.typeName}</li>
                        ))}
                    </div>
                    </div>
                    
                </div>
                <div className='card'>
                    <h3>Actions</h3>
                    <div className="card-content">
                        <div className="label-a">Number of actions:</div>
                        <div className="value-a">{valueCard.modelParams.noActions}</div>
                    </div>
                    {valueCard.modelParams.actionList.map(action => (
                            <div key={action.actionID} >
                                <div className='card-content'>
                                <div className="label-a">{action.actionName}</div>
                                <div className="value-a">{action.actionDescr}</div>
                                </div>
                            </div>
                        ))}
                </div>
            <div className='card'>
                <h3>Score information</h3>
                    <div className="card-content">
                        <div className="label-g">Temporal:</div>
                        <div className="value-g">{valueCard.scoreInfo.temporal ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Spatial:</div>
                        <div className="value-g">{valueCard.scoreInfo.spatial ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Deterministic:</div>
                        <div className="value-g">{valueCard.scoreInfo.deterministic ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Complicated actions:</div>
                        <div className="value-g">{valueCard.scoreInfo.complicatedActions ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Contradicting predictions:</div>
                        <div className="value-g">{valueCard.scoreInfo.contradictPred ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Standard language:</div>
                        <div className="value-g">{valueCard.scoreInfo.stdLang ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Parsable:</div>
                        <div className="value-g">{valueCard.scoreInfo.parsable ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Scalable:</div>
                        <div className="value-g">{valueCard.scoreInfo.scalable ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Fail performance:</div>
                        <div className="value-g">{valueCard.scoreInfo.failPerf ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="card-content">
                        <div className="label-g">Number of simplified actions:</div>
                        <div className="value-g">{valueCard.scoreInfo.noSimplifiedActions}</div>
                    </div>
                    </div>
      </div>
        </div>
    );
};

export default DisplayDomainData;
